import { useEnumStore } from '@/stores'

/**
 * 客户端类型
 */
export enum ClientType {
    None = 0,  // 保留为未填终端类型
    PCManager = 1,  // PC管理端
    PCTrade = 2,  // PC交易端
    Android = 3,  // 手机客户端_安卓
    Web = 4,  // 网页客户端
    Wechat = 5,  // 微信客户端
    IOS = 6,  // 手机客户端_苹果
    AccountOnline = 7,  // 网上开户客户端
    Invalid = 8,  // 无效终端编号
    Quote = 9,  // 报价终端
    TradeInterface = 10 // 交易接口
}

/**
 * 获取客户端类型列表
 * @returns 
 */
export function getClientTypeList() {
    const enumStore = useEnumStore()
    return enumStore.getEnumTypeList('clientType')
}

/**
 * 委托来源
 */
export enum OrderSrc {
    /// 客户端
    ORDERSRC_CLIENT = 1,
    /// 管理端
    ORDERSRC_MANAGE = 2,
    /// 风控服务
    ORDERSRC_RISK = 3,
    /// 交割服务
    ORDERSRC_DELIVERY = 4,
    /// 交易服务
    ORDERSRC_TRADE = 5,
    /// 交易日结
    ORDERSRC_DAYEND = 6,
    /// 商品强平
    ORDERSRC_EXPIREFORCECLOSE = 7,
    /// 管理端商品退市强平
    ORDERSRC_MANAGEFORCECLOSE = 8,
    /// 交易接口
    ORDERSRC_TRADEINTERFACE = 9,
    /// 交收服务商被动
    ORDERSRC_ENTRUSACCEPT = 10,
    /// 预埋触发
    ORDERSRC_PREPOSORDER = 11,
}

/// 最后更新时间枚举
export enum ELastUpdateTime {
    /// 枚举常量字典最后更新时间
    LastUpdateTime_DirctionaryUTime = 20,
    /// 错误码字典最后更新时间
    LastUpdateTime_ErrorcodeUTime = 21,
    /// 市场更新时间
    LastUpdateTime_MarketsUTime = 22,
    /// 商品更新时间
    LastUpdateTime_GoodsUTime = 23,
    /// 终端配置参数更新时间
    LastUpdateTime_ConfigUTime = 24,
    /// 风险协议书更新时间
    LastUpdateTime_RiskMsgUTime = 25,
    /// 交易日
    LastUpdateTime_TradeDate = 26,
    /// 菜单更新时间
    LastUpdateTime_MenuUTime = 27,
    /// 交收商品更新时间
    LastUpdateTime_DvGoodsUTime = 28,
}

/// 客户端类型
export enum EClientType {
    /// 保留为未填终端类型
    CLIENTTYPE_NONE = 0,
    /// PC管理端
    CLIENTTYPE_PC_MANAGER_CLIENT = 1,
    /// PC交易端
    CLIENTTYPE_PC_TRADE_CLIENT = 2,
    /// 手机客户端_安卓
    CLIENTTYPE_MOBILE_CLIENT_ANDROID = 3,
    /// 网页客户端
    CLIENTTYPE_WEBPAGE_CLIENT = 4,
    /// 微信客户端
    CLIENTTYPE_WECHAT_CLIENT = 5,
    /// 手机客户端_苹果
    CLIENTTYPE_MOBILE_CLIENT_IOS = 6,
    /// 网上开户客户端
    CLIENTTYPE_USERACCOUNT_ONLINE = 7,
    /// 无效终端编号
    CLIENTTYPE_INVALID = 8,
    /// 报价终端
    CLIENTTYPE_QUOTE_CLIENT = 9,
}

/// 交易属性
export enum ETradeProperty {
    /// 收益权(可做空)
    TRADEPROPERTY_CANSHORT = 1,
    ///  所有权(不可做空)
    TRADEPROPERTY_NOSHORT = 2,
    /// 期权
    TRADEPROPERTY_OPTION = 3,
    /// 现货
    TRADEPROPERTY_CANGOODS = 4,
    /// 参考行情
    TRADEPROPERTY_REFERENCEQUOTES = 5,
    /// 通道交易
    TRADEPROPERTY_CHANNELTRADE = 6,
    /// 币交易
    TRADEPROPERTY_COINEXCHANGE = 7,
    /// 场外期权
    TRADEPROPERTY_OTCOPTION = 8,
}

/// 交易模式
export enum ETradeMode {
    /// 做市
    TRADEMODE_MARKETMAKE = 10,
    /// 竞价
    TRADEMODE_BIDDING = 13,
    /// 通道交易
    TRADEMODE_ENTRUST_HEDGE = 15,
    /// 挂牌点选
    TRADEMODE_LISTING_SELECT = 16,
    /// 仓单贸易
    TRADEMODE_SPOT_WRTRADE = 17,
    /// 期权贸易
    TRADEMODE_OPTION = 18,
    /// 竞拍-降价式
    TRADEMODE_AUCTIONCUT = 19,
    /// 竞拍-竞价式
    TRADEMODE_AUCTIONBID = 20,
    /// 竞拍-大宗式
    TRADEMODE_AUCTIONBULK = 21,
    /// 受托竞价
    TRADEMODE_ENTRUSTBID = 22,
    /// 预售集采
    TRADEMODE_PRESALE = 23,
    /// 竞拍-降价式(无仓单)
    TRADEMODE_AUCTIONCUTNOWR = 24,
    /// 点价点选贸易
    TRADEMODE_POINTANDSELECT = 25,
    /// 挂牌期权
    TRADEMODE_LISTINGOPTION = 26,
    /// 招投标
    TRADEMODE_TENDER = 27,
    /// 币交易
    TRADEMODE_COINEXCHANGE = 32,
    /// 竞拍-荷兰式
    TRADEMODE_AUCTIONDUTCH = 34,
    /// 场外期权-单向
    TRADEMODE_OTCOPTION_ONEWAY = 35,
    /// 法币C2C
    TRADEMODE_COINC2C = 36,
    /// 预售一口价挂牌
    TRADEMODE_CPTRADE_LISTING = 40,
    /// 预售竞拍(大宗)
    TRADEMODE_CPTRADE_AUCTION_BULK = 41,
    /// 期现套利
    TRADEMODE_FSARBITRAGE = 42,
    /// 仓单回购
    TRADEMODE_WRREPURCHASE = 43,
    /// 现货贸易
    TRADEMODE_SPOT_TRADE = 44,
    /// 天津麦顿-商品掉期
    TRADEMODE_TJMD = 46,
    /// 廣陈优品-仓单预售
    TRADEMODE_CDYS = 47,
    /// 挂牌点价
    TRADEMODE_PRICING = 52,
    /// 全款商城
    TRADEMODE_MALL = 53,
    /// 千海金-铂金宝
    TRADEMODE_QHJ_BJB = 69,
    /// 海商报业商城
    TRADEMODE_HSBY_SHOP = 70,
    /// 预售挂牌
    TRADEMODE_CPTRADE_LS = 71,
    /// AI预约竞拍
    TRADEMODE_AUCTION_AI = 72,
    /// 尚志金宝宝
    TRADEMODE_SZDZ_JBB = 73,
    /// 挂牌点选-尚志
    TRADEMODE_SZDZ_LS = 75,
    /// 竞拍-金点拍
    TRADEMODE_SZDZ_JDP = 76,
    /// 现货商城
    TRADEMODE_SPOTSHOP = 77,
    /// 报价系统
    TRADEMODE_SPOTQUOTE = 78,
    /// 挂牌系统
    TRADEMODE_SPOTLISTING = 79,
    /// 千海金-饰品回收
    TRADEMODE_QHJ_SPHG = 97,
    /// 参考行情
    TRADEMODE_QHJ_CKHQ = 99,
}

/// 履约状态
export enum EPerformanceStatus {
    /// 待激活
    PERFORMANCESTATUS_INI = 1,
    /// 正常
    PERFORMANCESTATUS_NORMAL = 2,
    /// 处理错误
    PERFORMANCESTATUS_ERROR = 3,
    /// 违约待确认
    PERFORMANCESTATUS_BREACHING = 4,
    /// 违约
    PERFORMANCESTATUS_BREACHED = 5,
    /// 完成
    PERFORMANCESTATUS_FINISHED = 6,
    /// 违约已完成
    PERFORMANCESTATUS_BREACHE_FINISHED = 7,
    /// 释放冻结失败
    PERFORMANCESTATUS_UNFREEZE_FAIL = 8,
    /// 超时待处理
    PERFORMANCESTATUS_TIMEOUT_WAIT = 9,
    /// 超时关闭
    PERFORMANCESTATUS_TIMEOUT_FINISHED = 10,
}

/// 履约类型
export enum EPerformanceType {
    /// 通用
    PERFORMANCETYPE_NORMAL = 0,
    /// 交割
    PERFORMANCETYPE_DELIVERY = 1,
    /// 仓单贸易
    PERFORMANCETYPE_WRTRADE = 2,
    /// 预售采集
    PERFORMANCETYPE_PRESALE = 3,
    /// 竞拍-降价式 (无仓单)
    PERFORMANCETYPE_AUCTIONCUT = 4,
    /// 挂牌期权 (无仓单)
    PERFORMANCETYPE_LISTINGOPTION = 5,
    /// 竞拍-降价式
    PERFORMANCETYPE_AUCTIONLOWER = 6,
    /// 竞拍-竞价式
    PERFORMANCETYPE_AUCTIONUPPER = 7,
    /// 竞拍-大宗式
    PERFORMANCETYPE_AUCTIONBULK = 8,
    /// 竞拍-荷兰式
    PERFORMANCETYPE_AUCTIODUTCH = 9,
    /// 法币C2C
    PERFORMANCETYPE_COINC2C = 10,
    /// 报价系统
    PERFORMANCETYPE_SPOTQUOTE = 11,
    /// 挂牌系统
    PERFORMANCETYPE_SPOTLISTING = 12,
}

/// 付款方式
export enum EPaymentType {
    /// 冻结
    freeze = 1,
    /// 扣款
    cut = 2,
}

/// 履约步骤控制状态
export enum EHandleStatus {
    /// 开始
    PERFORMANCE_STEPHANDLESTATUS_BEGIN = 1,
    /// 结束
    PERFORMANCE_STEPHANDLESTATUS_FINISHED = 2,
    /// 冻结请求
    PERFORMANCE_STEPHANDLESTATUS_FREEZE_REQ = 3,
    /// 冻结返回成功
    PERFORMANCE_STEPHANDLESTATUS_FREEZE_RSP_SUC = 4,
    /// 冻结返回失败
    PERFORMANCE_STEPHANDLESTATUS_FREEZE_RSP_FAIL = 5,
    /// 扣款请求
    PERFORMANCE_STEPHANDLESTATUS_DEDUCT_REQ = 6,
    /// 扣款返回成功
    PERFORMANCE_STEPHANDLESTATUS_DEDUCT_RSP_SUC = 7,
    /// 扣款返回失败
    PERFORMANCE_STEPHANDLESTATUS_DEDUCT_RSP_FAIL = 8,
    /// 仓单转移请求
    PERFORMANCE_STEPHANDLESTATUS_RECEIPTTRANSFER_REQ = 9,
    /// 仓单转移返回成功
    PERFORMANCE_STEPHANDLESTATUS_RECEIPTTRANSFER_RSP_SUC = 10,
    /// 仓单转移返回失败
    PERFORMANCE_STEPHANDLESTATUS_RECEIPTTRANSFER_RSP_FAIL = 11,
    /// 加钱请求
    PERFORMANCE_STEPHANDLESTATUS_ADDMONEY_REQ = 12,
    /// 加钱返回成功
    PERFORMANCE_STEPHANDLESTATUS_ADDMONEY_RSP_SUC = 13,
    /// 加钱返回失败
    PERFORMANCE_STEPHANDLESTATUS_ADDMONEY_RSP_FAIL = 14,
    /// 解冻仓单头寸请求
    PERFORMANCE_STEPHANDLESTATUS_UNFREZZE_WRPOSTION_REQ = 15,
    /// 解冻仓单头寸返回成功
    PERFORMANCE_STEPHANDLESTATUS_UNFREZZE_WRPOSTION_RSP_SUC = 16,
    /// 解冻仓单头寸返回失败
    PERFORMANCE_STEPHANDLESTATUS_UNFREZZE_WRPOSTION_RSP_FAIL = 17,
    /// 解冻库位请求
    PERFORMANCE_STEPHANDLESTATUS_UNFREZZE_WAREHOUSE_REQ = 18,
    /// 解冻库位返回成功
    PERFORMANCE_STEPHANDLESTATUS_UNFREZZE_WAREHOUSE_RSP_SUC = 19,
    /// 解冻库位返回失败
    PERFORMANCE_STEPHANDLESTATUS_UNFREZZE_WAREHOUSE_RSP_FAIL = 20,
    /// 卖方剩余金额解冻请求
    PERFORMANCE_STEPHANDLESTATUS_SELLER_UNFREZZE_REQ = 21,
    /// 卖方剩余金额解冻成功
    PERFORMANCE_STEPHANDLESTATUS_SELLER_UNFREZZE_RSP_SUC = 22,
    /// 卖方剩余金额解冻失败
    PERFORMANCE_STEPHANDLESTATUS_SELLER_UNFREZZE_RSP_FAIL = 23,
}

/// 履约步骤状态
export enum EStepStatus {
    /// 待开始
    PERFORMANCE_STEPSTATUS_PENDING = 1,
    /// 进行中
    PERFORMANCE_STEPSTATUS_EXECUTING = 2,
    /// 已完成
    PERFORMANCE_STEPSTATUS_FINISHED = 3,
    /// 延期(进行中)
    PERFORMANCE_STEPSTATUS_EXECUTING_DELAY = 4,
    /// 失败
    PERFORMANCE_STEPSTATUS_FAILED = 5,
    /// 自动完成
    PERFORMANCE_STEPSTATUS_FINISHED_AUTO = 6,
    /// 超时关闭
    PERFORMANCE_STEPSTATUS_FINISHED_TIMEOUT = 7,
}

/// 履约步骤类型
export enum EStepType {
    /// 买方支付
    PERFORMANCE_STEPTYPE_BUYER_PAYMENT = 1,
    /// 卖方收款
    PERFORMANCE_STEPTYPE_SELLER_RECEIVE = 2,
    /// 买方自提
    PERFORMANCE_STEPTYPE_BUYER_PICKUP = 3,
    ///  卖方发货
    PERFORMANCE_STEPTYPE_SELLER_SENDGOODS = 4,
    /// 买方确认货
    PERFORMANCE_STEPTYPE_BUYER_CONFIRMGOODS = 5,
    /// 卖方发票
    PERFORMANCE_STEPTYPE_SELLER_SENDINVOICE = 6,
    /// 买方确认票
    PERFORMANCE_STEPTYPE_BUYER_CONFIRMINVOICE = 7,
    /// 仓单转移
    PERFORMANCE_STEPTYPE_WRMOVE = 8,
    /// 释放卖方履约前剩余保证金
    PERFORMANCE_STEPTYPE_SELLER_UNFREEZE = 9,
    /// 溢短
    PERFORMANCE_STEPTYPE_OVER_SHORT = 10,
    /// 生成合同
    PERFORMANCE_STEPTYPE_BUILD_AGREEMENT = 11,
    /// 运费
    PERFORMANCE_STEPTYPE_BUILD_EXPRESSFEE = 12,
    /// 确认付款(买方)
    PERFORMANCE_STEPTYPE_COINC2C_CONFIRM_PAYMENT = 90,
    /// 确认放行(卖方)
    PERFORMANCE_STEPTYPE_COINC2C_CONFIRM_PASS = 91,
    /// 买方支付(直接扣款)
    PERFORMANCE_STEPTYPE_BUYER_PAYMENT_NOW = 92,
}

export enum EFinanceType {
    /// -融资回购
    FinanceBuyBack = 1,
}

/// 交个状态
export enum EDeliveryStatus {
    /// 待成交
    DELIVERYSTATUS_PENDING = 1,
    /// 已成交
    DELIVERYSTATUS_TRADED = 2,
    /// 成交失败
    DELIVERYSTATUS_FAILED = 3,
    /// 履约完成
    DELIVERYSTATUS_PERFORMANCEFINISHED = 4,
}

/// 单据方向
export enum EOrderDirection {
    /// 订单买方向
    BUY = 0,
    /// 订单卖方向
    SELL = 1,
}

/// 价格方式
export enum EWrPriceType {
    /// 固定价
    fixed = 1,
    /// 浮动价
    float = 2,
    /// 贸易圈
    member = 3,
    /// 协议指定
    point = 4,
}


/// 价格类型
export enum EPriceMode {
    /// 市价
    PRICEMODE_MARKET = 1,
    /// 限价（固定价）
    PRICEMODE_LIMIT = 2,
    /// 浮动价
    PRICEMODE_FLOAT = 3,
}

/// 订单状态
export enum EOrderStatus {
    ///  委托请求
    REQUEST = 1,
    ///  待冻结
    WAITFREEZE = 2,
    ///  委托成功
    SUCCEED = 3,
    ///  委托失败
    FAILED = 4,
    ///  配对成功
    MATCHED = 5,
    ///  已撤
    CANCELED = 6,
    ///  部成
    LISTING_PARTTRADE = 7,
    ///  已成
    DEALED = 8,
    ///  部成部撤
    PARTIALCANCELED = 9,
    ///   成交失败
    DEALFAILED = 10,
    ///  委托拒绝
    DENIED = 11,
    ///  经过摘牌(先摘后挂专用)
    MATCH = 12,
    ///  冻结成功(通道交易专用)
    FREEZE_SUCCESS = 13,
    ///  通道已撤
    CHANNEL_CANCELED = 14,
    ///  通道部成部撤
    CHANNEL_PARTIALCANCELED = 15,
    ///  成交失败违约(荷兰式竞拍专用)
    BREACHDEALFAILED = 16,
    ///  冻结PD成功
    FREEZE_PD_SUCCESS = 17,
    ///  冻结PD失败
    FREEZE_PD_FAILED = 18,
    ///  冻结能量成功
    FREEZE_MP_SUCCESS = 19,
    ///  冻结能量失败
    FREEZE_MP_FAILED = 20,
    ///  预约已报价
    AI_QUOTE_SUCCESS = 21,
    ///  过期未付
    PAY_PAY_EXPIRED = 22,
    ///  优惠券处理中
    COUPPOSITION = 23,
    /// 仓单生成失败
    WR_FAILED = 24,
    /// 首付扣款失败
    FIRSTPAYMENT_DEDUCT_FAILED = 25,
    /// 履约失败
    PERFORMANCE_FAILED = 26,
    /// 撤单解冻贷款失败
    CANCELE_UNFREZZE_FAILED = 27,
}

/// 对冲内盘委托状态
export enum EChannelInnerOrderStatus {
    /// 委托请求
    INNERSTATUS_ORDERREQ = 1,
    /// 冻结成功
    INNERSTATUS_FREEZESUCC = 2,
    /// 委托失败
    INNERSTATUS_ORDERFAIL = 3,
    /// 委托部成部失败
    INNERSTATUS_PARTIAL_TRADE_FAIL = 4,
    /// 委托成功
    INNERSTATUS_ORDERSUCC = 5,
    /// 全部撤销
    INNERSTATUS_ALLCANCEL = 6,
    /// 部成部撤
    INNERSTATUS_PARTIAL_TRADE_CANCELED = 7,
    /// 部成部撤部失败
    INNERSTATUS_PARTIAL_TRADE_CANCELED_FAIL = 8,
    /// 全部成交
    INNERSTATUS_ALLTRADE = 9,
}

/// 提货方式
export enum ETakeMode {
    /// 2:自提
    oneself = 2,
    /// 3:配送(邮寄)
    distribution = 3,
}

/// 提货状态
export enum ETakeOrderStatus {
    /// 1:备货中
    InStock = 1,
    /// 2:待取货(自提)
    UnPickUp = 2,
    /// 3:已取货(自提)
    PickUp = 3,
    /// 4:待收货(邮寄)
    UnRecived = 4,
    /// 5:已收货(邮寄)
    Recived = 5,
    /// 6:自动收货(邮寄)
    AutoRecived = 6,
    /// 7:已拒绝
    Rejiect = 7,
    /// 8:已撤销
    Cancel = 8,
}

/// 定投状态
export enum ERegularlyStrategyStatus {
    /// 1:正常
    normal = 1,
    /// 2:暂停
    resume = 2,
    /// 3:终止
    stop = 3,
}

/// 定投状态
export enum Etriggerstatus {
    /// 1:成功
    success = 1,
    /// 2:失败
    failure = 2,
}

/// 终端来源类型
export enum ESrcType {
    /// 1:管理端
    manager = 1,
    /// 2:终端
    client = 2,
}

/// 定投类型
export enum ERegularlyMode {
    /// 按重量
    Qty = 1,
    /// 按金额
    Amount = 2,
}

/// 定投频率
export enum ERegularlyCycle {
    /// 每周
    Week = 1,
    /// 每月
    Month = 2,
}

/// 合同类型
export enum EScfContractType {
    /// 仓单回购
    SCF_CONTRACT_TYPE_WRR = 1,
    /// 仓单质押
    SCF_CONTRACT_TYPE_WRM = 2,
    /// 合作套保
    SCF_CONTRACT_TYPE_CH = 3,
    /// 资金贷款
    SCF_CONTRACT_TYPE_LOAN = 4,
    /// 融资单
    SCF_CONTRACT_TYPE_ORDER = 5,
    /// 融资回购
    SCF_CONTRACT_TYPE_ORR = 6,
}

/// 合同状态
export enum EScfContractStatus {
    /// 合同状态 - 1:待确认
    unConfirmed = 1,
    /// 2:已确认
    confirmed = 2,
    /// 3:确认拒绝
    refusedConfirmed = 3,
    /// 4:已支付保证金
    payedMargin = 4,
    /// 5:已激活
    activated = 5,
    /// 6:已违约
    defaulted = 6,
    /// 7:到期结束 8:延期结束 9:违约结束 10:已注销 11:已关闭 99:未提交
    limitedEnd = 7,
    /// 8:延期结束
    delayEnd = 8,
    /// 9:违约结束
    defaultedEnd = 9,
    /// 10:已注销
    cancelled = 10,
    /// 11:已关闭
    closed = 11,
    /// 99:未提交
    unsubmit = 99,
}

/// 提货状态
export enum EPickUpGoodsStatus {
    /// 1:正常
    normal = 1,
    /// 2:停用
    stop = 2,
    /// 3:注销
    cancel = 3,
}


/// 关联商品类型
export enum ERelatedGoodsType {
    /// 期货合约
    ERMS2_RELATED_GOODS_TYPE_FUTURE = 1,
    /// 现货品种
    ERMS2_RELATED_GOODS_TYPE_SPOT = 2,
}

/// 账户状态
export enum EAccountStatus {
    /// 待激活
    ACCOUNTSTATUS_INACTIVE = 1,
    /// 待审核
    ACCOUNTSTATUS_PENDINGAUDIT = 2,
    /// 待复审
    ACCOUNTSTATUS_PENDINGREAUDIT = 3,
    /// 正常
    ACCOUNTSTATUS_NORMAL = 4,
    /// 审核拒绝
    ACCOUNTSTATUS_REJECT = 5,
    /// 已注销
    ACCOUNTSTATUS_CANCELLED = 6,
}

/// 用户类型
export enum EUserInfoType {
    /// 个人
    USERINFOTYPE_PERSON = 1,
    /// 企业
    USERINFOTYPE_COMPANY = 2,
}

/// 仓单贸易议价申请状态
export enum ETradeBargainApplyStatus {
    /// 待确认
    BARGAINAPPLYSTATUS_PENDING = 1,
    /// 已确认
    BARGAINAPPLYSTATUS_CONFIRMED = 2,
    /// 已拒绝
    BARGAINAPPLYSTATUS_REJECTED = 3,
    /// 已撤销
    BARGAINAPPLYSTATUS_CANCEL = 4,
    /// 系统撤销
    BARGAINAPPLYSTATUS_SYSCANCEL = 5,
    /// 处理失败
    BARGAINAPPLYSTATUS_FAILED = 6,
}

/// 仓单申请类型- 1:预约入库 2:预约出库 3:入库注册 4:出库注销
export enum EWRApplyType {
    /// 预约入库
    WR_APPLYTYPE_APPOINT_IN = 1,
    /// 预约出库
    WR_APPLYTYPE_APPOINT_OUT = 2,
    /// 入库注册
    WR_APPLYTYPE_REJIEST_IN = 3,
    /// 出库注销
    WR_APPLYTYPE_CANCEL_OUT = 4,
}

/// 仓单申请状态
export enum EWRApplyStatus {
    /// 待初审
    WR_APPLYSTATUS2_SUBMITTED = 1,
    /// 初审通过
    WR_APPLYSTATUS2_PASS = 2,
    /// 初审拒绝
    WR_APPLYSTATUS2_REJECT = 3,
    /// 初审失败
    WR_APPLYSTATUS2_FAILED = 4,
    /// 复审通过
    WR_APPLYSTATUS2_RECONFIRM_OK = 5,
    /// 复审拒绝
    WR_APPLYSTATUS2_RECONFIRM_REJECT = 6,
    /// 复审失败
    WR_APPLYSTATUS2_RECONFIRM_FAILED = 7,
    /// 已撤销
    WR_APPLYSTATUS2_RECONFIRM_CANCEL = 8,
}

/// 产品类型
export enum EProductType {
    /// 标准仓单
    ERMCP_PRODUCT_TYPE_STANDARD_WR = 1,
    /// 等标
    ERMCP_PRODUCT_TYPE_STANDARD = 2,
    /// 非标
    ERMCP_PRODUCT_TYPE_NONSTANDARD = 3,
}


/// 订单类型
export enum EOrderType {
    /// 市价建仓
    OPEN_MARKET = 1,
    /// 限价建仓
    OPEN_LIMIT = 2,
    /// 市价平仓
    CLOSE_MARKET = 3,
    /// 限价平仓
    CLOSE_LIMIT = 4,
    /// 先平后建
    CLOSETHENOPEN = 5,
    /// 止盈止损
    SPSL = 6,
    /// 交割协议转让
    DELIVERY_TRANSFER = 7,
    /// 交割协议平仓
    DELIVERY_CLOSE = 8,
    /// 交割成交（所有权）
    DELIVERY_TRADE = 9,
    /// 受托市价
    ENTRUST_MARKET = 10,
    /// 受托限价
    ENTRUST_LIMIT = 11,
    /// 管理端协议转让
    MANAGE_TRANSFER = 12,
}

/// 委托来源
export enum EOrderSrc {
    /// 客户端
    ORDERSRC_CLIENT = 1,
    /// 管理端
    ORDERSRC_MANAGE = 2,
    /// 风控服务
    ORDERSRC_RISK = 3,
    /// 交割服务
    ORDERSRC_DELIVERY = 4,
    /// 交易服务
    ORDERSRC_TRADE = 5,
    /// 交易日结
    ORDERSRC_DAYEND = 6,
    /// 商品强平
    ORDERSRC_EXPIREFORCECLOSE = 7,
    /// 管理端商品退市强平
    ORDERSRC_MANAGEFORCECLOSE = 8,
    /// 交易接口
    ORDERSRC_TRADEINTERFACE = 9,
    /// 交收服务商被动
    ORDERSRC_ENTRUSACCEPT = 10,
    /// 预埋触发
    ORDERSRC_PREPOSORDER = 11,
}

/// 运行阶段
export enum ERunStep {
    /// 集合竞价
    RUNSTEP_BIDDINGPRICE = 1,
    /// 连续竞价(交割)
    RUNSTEP_BIDDINGCONTINUOUS = 2,
    /// 补充交割
    RUNSTEP_SUPPLEMENTDELIVERY = 3,
    /// 确认行权
    RUNSTEP_CONFIRMEXERCISE = 4,
}

/// 止盈止损单单据状态
export enum ETriggerOrderStatus {
    /// 待触发
    Triggering = 1,
    /// 已触发
    Triggered = 2,
    /// 已撤单
    Canceled = 3,
    /// 已失效
    Invalid = 4,
    /// 委托成功
    Success = 5,
    /// 委托失败
    Failed = 6,
}

/// 有效类型
export enum EValidType {
    /// 当日有效
    VALIDTYPE_DR = 1,
    /// 本周有效
    VALIDTYPE_BZ = 2,
    /// 指定日期有效
    VALIDTYPE_ZDRQ = 3,
    /// 一直有效
    VALIDTYPE_YZ = 4,
    /// 指定时间有效
    VALIDTYPE_GTT = 5,
}

/// 触发条件
export  enum ETriggerOperator {
    /// 大于等于
    TRIGGEROPERATOR_GREATEROREQUAL = 1,
    /// 小于等于
    TRIGGEROPERATOR_LESSOREQUAL = 2,
}

/// 期权类型
export enum EOptionType {
    /// 基金配售
    OPTIONTYPE_CALL = 1,
    /// 认沽
    OPTIONTYPE_PUT = 2,
    /// 基金配售 + 认沽
    OPTIONTYPE_CALL_PUT = 3,
}

/// 升贴水类型
export enum EPriceMoveType {
    /// 品牌
    PRICEMOVETYPE_BRAND = 1,
    /// 品质
    PRICEMOVETYPE_QUALITY = 2,
    /// 规格
    PRICEMOVETYPE_SPECIFICATION = 3,
    /// 仓库
    PRICEMOVETYPE_WAREHOUSE = 4,
    /// 月份
    PRICEMOVETYPE_MONTH = 5,
}

/// 止盈止损委托类型
export enum ESPSLType {
    /// 止盈
    SPSLTYPE_SP = 1,
    /// 止损
    SPSLTYPE_SL = 2,
    /// 撤销
    SPSLTYPE_CANCEL = 3,
    /// 止盈止损价
    SPSLTYPE_SPSL = 4,
}

/// 履约步骤启动类型
export enum EStepLanchType {
    /// 系统自动
    PERFORMANCE_STEPLANCHTYPE_SYSTEM = 1,
    /// 手动
    PERFORMANCE_STEPLANCHTYPE_MANUAL = 2,
}

/// 仓单贸易类型
export enum EWRTradeType {
    /// 挂牌
    WRTRADEORDERTYPE_LISTING = 1,
    /// 摘牌
    WRTRADEORDERTYPE_DELISTING = 2,
}

/// 成交类型
export enum ETradeType {
    /// 正常委托成交
    NORMAL_ORDER_DEAL = 1,
    /// 风控斩仓成交
    DIRECTED_MM_DEAL = 2,
    /// 修正持仓成交
    DELIVERY_AGREECLOSE_DEAL = 3,
    /// 管理端斩仓成交
    DELIVERY_AGREEREDUCE_DEAL = 4,
    /// 锁仓赠送成交
    EXPIRE_FORCE = 5,
    /// 基金配售
    RISK_FORCE = 6,
    /// 场外手动成交
    AGREECLOSE_MANAGE_DEAL = 7,
    /// API成交
    WAREHOUSETOPOSITION = 8,
    ///  协议转让成交
    DELIVERY_TRANSFER = 9,
    /// 受托竞价成交(接单)
    ENTRUSTBID_ACCEPT = 10,
    /// 协议转让成交
    MANAGE_PROTO_TRANSFER = 11,
    /// 管理端强平成交
    MANAGE_FORCE_CLOSE = 12,
    /// 违约平仓成交
    BREACK_CLOSE = 13,
    /// 场外期权单向成交
    TRADETYPE_OPTIONONEWAY = 14,
    /// 冻结头寸解冻申请
    TRADETYPE_FREEZEPOS_UNFREEZE_REQUEST = 15,
    /// 冻结头寸商品配售
    TRADETYPE_FREEZEPOS_GOODS_RATION = 16,
    /// 冻结头寸商品转让
    TRADETYPE_FREEZEPOS_GOODS_TRANSFER = 17,
    /// 冻结头寸商品回购
    TRADETYPE_FREEZEPOS_GOODS_BUYBACK = 18,
    /// 冻结头寸商品提货
    TRADETYPE_FREEZEPOS_GOODS_PICKUP = 19,
    /// 冻结头寸结算解冻
    TRADETYPE_FREEZEPOS_RECKON_UNFREEZE = 20,
    /// 转换外部商品
    TRADETYPE_CONVERT_OUTGOODS = 21,
    /// 预售商品头寸转入
    TRADETYPE_CP_POSITION_TRANSFER_IN = 22,
    /// 预售商品头寸转入注销
    TRADETYPE_CP_POSITION_TRANSFER_IN_CANCEL = 23,
    /// 预售商品成交
    TRADETYPE_CP_PRESALE_DEAL = 24,
    /// 预售商品卖家增加头寸
    TRADETYPE_CP_PRESALE_SELLER_ADD = 25,
    /// 预售商品结束清理
    TRADETYPE_CP_PRESALE_CLEAR = 26,
    /// 融资买入成交
    TRADETYPE_FINANCE_ORDERBUY = 27,
    /// 提货减仓成交
    TRADETYPE_PICKUP_DEAL = 28,
}

/// 操作类型
export enum EOperateType {
    /// 委托撤单
    OPERATETYPE_ORDERCANCEL = 1,
    /// 预埋单撤单
    PREORDER_ORDERCANCEL = 20,
}

/// 性别
export enum ESex {
    /// 女
    SEX_FEMALE = 0,
    /// 男
    SEX_MALE = 1,
}

/// 操作类型
export enum EChannelOperateType {
    /// 正常下单
    ORDER = 1,
    /// 斩仓委托
    RISK = 2,
    /// 强平委托
    TRADE = 3,
    /// 人工核单
    MANUAL = 4,
    /// 止盈止损
    SPSLOrder = 5,
    /// API委托
    API = 6,
}

/// 下单类型
export enum EBuildType {
    /// 建仓
    BUILDTYPE_OPEN = 1,
    /// 平仓
    BUILDTYPE_CLOSE = 2,
    /// 先平后建
    BUILDTYPE_CLOSETHENOPEN = 3,
}

/// 挂牌点选类型
export enum EListingSelectType {
    /// 挂牌
    LISTINGSELECTTYPE_LISTING = 1,
    /// 摘牌
    LISTINGSELECTTYPE_DELISTING = 2,
    /// 先摘后挂
    LISTINGSELECTTYPE_DELISTINGTHENLISTING = 3,
}

/// 摘牌类型
export enum EDelistingType {
    /// 价格最优
    DELISTINGTYPE_PRICE = 1,
    /// 点选成交
    DELISTINGTYPE_SELECTED = 2,
}

/// 交货模式
export enum EPerformanceWay {
    /// 履约计划
    PERFORMANCEWAY_PALN_PERFORMANCE = 1,
    /// 分步履约
    PERFORMANCEWAY_STEP_PERFORMANCE = 2,
    /// 分步提货
    PERFORMANCEWAY_STEP_TAKE = 3,
}


/// 费用算法
export enum EFeeAlgorithm {
    /// 比率
    FEEALGORITHM_RATIO = 1,
    /// 固定
    FEEALGORITHM_FIXED = 2,
}

/// 履约步骤执行方
export enum EExecuteSide {
    /// 买方
    PERFORMANCE_EXECUTESIDE_BUYER = 1,
    /// 卖方
    PERFORMANCE_EXECUTESIDE_SELLER = 2,
}

/// 期货下单价格类型
export enum ATPPriceType {
    /// 对手价
    OPPONENT = 0,
    /// 最新价
    LAST = 1,
    /// 市价
    MARKET = 2,
    /// 超价
    SUPER = 3,
}

/// 订单操作类型
export enum EOrderOperateType {
    /// 正常下单
    ORDEROPERATETYPE_NORMAL = 1,
    /// 斩仓
    ORDEROPERATETYPE_RISK = 2,
    /// 转单
    ORDEROPERATETYPE_TRANSFER = 3,
    /// 结算撤单
    ORDEROPERATETYPE_RECKON_CANCEL = 4,
    /// 系统卖出(适用于先平后建的卖出)
    ORDEROPERATETYPE_SYS_CLOSE = 5,
    /// 行情源报价
    ORDEROPERATETYPE_QUOTEPRICE = 6,
    /// （结算)到期强平
    ORDEROPERATETYPE_ONTIME_CLOSE = 7,
    /// （结算)协议转让
    ORDEROPERATETYPE_DEAL_CLOSE = 8,
    /// 系统对冲单
    ORDEROPERATETYPE_SYS_HEDGE = 9,
    /// （结算)到期无效
    ORDEROPERATETYPE_RECKON_INVALID = 10,
    /// 交割协议转让
    ORDEROPERATETYPE_DELIVERY_TRANSFER = 11,
    /// 交割协议平仓
    ORDEROPERATETYPE_DELIVERY_CLOSE = 12,
    /// 交割成交（所有权）
    ORDEROPERATETYPE_DELIVERY_TRADE = 13,
    /// 管理端强行平仓
    ORDEROPERATETYPE_MANAGEFORCE_CLOSE = 14,
    /// 管理端协议转让
    ORDEROPERATETYPE_MANAGE_TRANSFER = 15,
    /// 管理端强行平仓阶段2
    ORDEROPERATETYPE_MANAGEFORCE_CLOSE_LEVEL2 = 16,
    /// 违约平仓
    ORDEROPERATETYPE_BREACK_CLOSE = 17,
    /// 管理端强行撤单
    ORDEROPERATETYPE_MANAGEFORCE_CANCEL = 18,
    /// 预埋单委托
    ORDEROPERATETYPE_PREPOSORDER_ORDER = 19,
    /// 预埋单撤单
    ORDEROPERATETYPE_PREPOSORDER_CANCEL = 20,
    /// 风控撤单
    ORDEROPERATETYPE_RISK_CANCEL = 21,
    /// （结算)会员到期强平
    ORDEROPERATETYPE_ONTIME_MEMBER_CLOSE = 22,
    /// 融资买入
    ORDEROPERATETYPE_BUYBYFINANCE = 23,
    /// 按单平仓
    ORDEROPERATETYPE_HOLDER_CLOSE = 24,
}

/// 业务类型
///
/// - AuthSignup: 三方登录注册业务
/// - MobileSignin: 手机号码登录
export enum CheckMobileType {
    AuthSignup,
    MobileSignin,
}

/// 仓库类型
export enum WareHouseType {
    /// 厂库
    factory = 1,
    /// 自有库
    own =  2,
    /// 合作库
    cooperation = 3,
}


/// 账户类型
export enum EUserType {
    /// 交易所
    USERTYPE_EXCHANGE = 1,
    /// 机构
    USERTYPE_AREA = 2,
    /// 会员子机构
    USERTYPE_SUBAREA = 3,
    /// 经纪人
    USERTYPE_BROKER = 4,
    /// 投资者
    USERTYPE_INVESTOR = 5,
    /// 客户(风管云平台)
    USERTYPE_CUSTOMER = 6,
    /// 企业成员(风管云平台)
    USERTYPE_ENTERPRISE_MEMBERS = 7,
}

/// 母账号类型
export enum EHedgeAccountType {
    /// 下单母账号
    HEDGEACCOUNTTYPE_NORMAL = 1,
    /// 跟单母账号
    HEDGEACCOUNTTYPE_PROGRAMMATIC = 2,
}

/// 签约状态
export enum ESignStaus {
    /// 未签约
    UNSIGN = 1,
    /// 签约待审核
    WAITCONFIRM_SIGN = 2,
    /// 签约中
    SIGNING = 3,
    /// 已签约
    SIGNED = 4,
    /// 解约待审核
    CANCELSIGN = 5,
    /// 解约中
    CANCELSIGNING = 6,
    /// 已解约
    CANCELSIGNED = 7,
    /// 已解绑
    UNBINDED = 8,
    /// 绑卡中
    BINGDING = 9,
    /// 审核拒绝
    CONFIRM_REFUSE = 10,
}

/// 关联模式
export enum ERelateMode {
    /// 1:自动关联
    AUTO = 1,
    /// 2:手动关联
    MANUAL = 2,
    /// 3:解绑关联
    UNLINK = 3,
}

/// 关联状态
export enum ELinkStatus {
    /// 成功
    SUCCESS = 1,
    /// 失败
    FAILD = 2,
    /// 解绑
    UNBIND = 3,
}



